import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    description: {
      end: '.\nOnce downloaded, your quote can no longer be edited.',
      link: 'see our article on the subject',
      start:
        'Before downloading your quote, you must assign it a number. To learn more,\xa0',
    },
    errorMessage:
      'An error occurred while marking your quote as sent. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    submit: 'Download my quote',
    successMessage: 'Your quote n°{0} has been successfully marked as sent!',
    title: 'Finalise your quote',
  },
  fr: {
    cancel: 'Annuler',
    description: {
      end: '.\nUne fois téléchargé, votre devis ne pourra plus être modifié.',
      link: 'consultez notre article sur le sujet',
      start:
        'Avant de télécharger votre devis, vous devez lui attribuer un numéro. Pour en savoir plus,\xa0',
    },
    errorMessage:
      'Une erreur est survenue lors du marquage de votre devis comme envoyé. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    submit: 'Télécharger mon devis',
    successMessage: 'Votre devis n°{0} a bien été marqué comme envoyé\xA0!',
    title: 'Finalisez votre devis',
  },
} as const);
